import React from 'react';
import { Container, Row } from 'react-bootstrap';

import PageHeader from "./components/PageHeader";
import ActionHeader from "./components/ActionHeader";
import DataTable from "./components/DataTable";
import InsertData from "./components/InsertData";
import TableSelector from "./components/TableSelector";
import useDatabaseTables from "./components/useDatabaseTables";

function InsertPage() {
  const API_URL = process.env.REACT_APP_API_URL;
  const {
    resultsTable,
    selectedTable,
    setSelectedTable,
    results,
    fetchTableData,
    resetResults
  } = useDatabaseTables(API_URL);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchTableData(selectedTable);
  };

  return (
    <Container className="mt-5">

      <PageHeader title="Inserimento riga" />

      <TableSelector
        resultsTable={resultsTable}
        selectedTable={selectedTable}
        setSelectedTable={(val) => { setSelectedTable(val); resetResults(); }}
        onSubmit={handleSubmit}
      />

      {results && results.columns && (
        <>
          <Row className="mt-5">
            <DataTable columns={results.columns} rows={results.rows} />
          </Row>
          
          <Row className="mt-5 mb-5">
            <ActionHeader actionTitle="🆕 Inserisci riga" />

            <InsertData 
              columns={results.columns} 
              tableName={selectedTable} 
              onInsert={() => fetchTableData(selectedTable)} 
            />
          </Row>
        </>
      )}
    </Container>
  );
}

export default InsertPage;
